import { createSelector } from '@reduxjs/toolkit';
import { storeSelector } from '../../Global/StoreSelector';

const moonList = createSelector(storeSelector, (state) => state.moonList.moonList);
const isOwner = createSelector(
  storeSelector,
  (state) => state.user.currentUser?.id === state.moonList.moonList?.author.id
);
const state = createSelector(storeSelector, (state) => state.moonList.state);

export default {
  moonList,
  isOwner,
  state
};
